<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M9.462 13h8.692l-2.758-3.654l-2.454 3.077l-1.588-1.885zm-5.847 6.77q-.67 0-1.143-.473Q2 18.825 2 18.154V7.077h1v11.077q0 .27.173.442t.442.173H19v1zm3-3q-.67 0-1.143-.473Q5 15.825 5 15.154V4.615q0-.67.472-1.143Q5.944 3 6.615 3h4.962l2 2h6.808q.67 0 1.143.472q.472.472.472 1.143v8.539q0 .671-.472 1.143t-1.143.472zm0-1h13.77q.269 0 .442-.174t.173-.442V6.615q0-.269-.173-.442T20.385 6h-7.21l-2-2h-4.56q-.269 0-.442.173T6 4.615v10.539q0 .27.173.442t.442.173m-.615 0V4z"
    />
  </svg>
</template>

<script>
export default {};
</script>
